export default __webpack_public_path__ + "6ca1b0a0dd167b0f6642541a0ca561c9.webp";